import classnames from "classnames";
import ReadOnlyField from "../ReadOnlyField";
import React from "react";

export default ({item, col = 2, marginBottom = 3}) =>
    <div className={`mb-${marginBottom} col-12 ` + classnames({'col-sm-6' : 2 === col}) + 'position-relative'}>
        <ReadOnlyField label={item.label} value={item.value} />
    </div>;
